import React from 'react';

export const SphereLogoWhYes = ({ className }) => (
    <svg className={className} viewBox="0 0 320 300" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.6" d="M161 246C207.944 246 246 207.944 246 161C246 114.056 207.944 76 161 76C114.056 76 76 114.056 76 161C76 207.944 114.056 246 161 246Z" fill="white" />
        <path opacity="0.8" d="M161 226C196.898 226 226 196.899 226 161C226 125.102 196.898 96 161 96C125.102 96 96 125.102 96 161C96 196.899 125.102 226 161 226Z" fill="url(#paint0_radial_2232_1965)" />
        <path d="M224.279 146.24C226.779 156.795 226.552 167.804 223.619 178.249C220.686 188.694 215.141 198.238 207.497 206L97.4478 174.682C95.2439 164.492 95.56 153.925 98.3697 143.881C101.179 133.838 106.399 124.615 113.584 117L224.279 146.24Z" fill="white" />
        <g style={{ mixBlendMode: 'multiply' }}>
            <path d="M161 226C196.898 226 226 196.899 226 161C226 125.102 196.898 96 161 96C125.102 96 96 125.102 96 161C96 196.899 125.102 226 161 226Z" fill="white" />
        </g>
        <defs>
            <radialGradient id="paint0_radial_2232_1965" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(115.847 154.492) scale(79.0381)">
                <stop stop-color="#F4F4F4" />
                <stop offset="1" stop-color="#D8D8D8" />
            </radialGradient>
        </defs>
    </svg>
);